import { render } from "./OpinionItem.vue?vue&type=template&id=6f415138&scoped=true"
import script from "./OpinionItem.vue?vue&type=script&lang=js"
export * from "./OpinionItem.vue?vue&type=script&lang=js"

import "./OpinionItem.vue?vue&type=style&index=0&id=6f415138&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f415138"]])

export default __exports__